var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondividi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.906,
    height: 24.026,
    viewBox: "0 0 23.906 24.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3381",
    "data-name": "Raggruppa 3381",
    transform: "translate(-20275.494 2174)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_98",
    "data-name": "Ellisse 98",
    cx: 4.839,
    cy: 4.839,
    rx: 4.839,
    ry: 4.839,
    transform: "translate(20281.215 -2173)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5884",
    "data-name": "Tracciato 5884",
    d: "M15.436,15.092a14.05,14.05,0,0,0-1.6-.092,13.117,13.117,0,0,0-6.495,1.661,8.736,8.736,0,0,0-3.992,4.521A1.21,1.21,0,1,0,5.622,22a6.332,6.332,0,0,1,2.921-3.238,10.438,10.438,0,0,1,4.27-1.294A3.636,3.636,0,0,1,15.436,15.092Z",
    transform: "translate(20272.223 -2174.691)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5885",
    "data-name": "Tracciato 5885",
    d: "M18,14v9.678",
    transform: "translate(20275.313 -2174.902)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5886",
    "data-name": "Tracciato 5886",
    d: "M23.678,18H14",
    transform: "translate(20274.473 -2174.063)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_99",
    "data-name": "Ellisse 99",
    cx: 4.839,
    cy: 4.839,
    rx: 4.839,
    ry: 4.839,
    transform: "translate(20281.215 -2173)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5889",
    "data-name": "Tracciato 5889",
    d: "M15.436,15.092a14.05,14.05,0,0,0-1.6-.092,13.117,13.117,0,0,0-6.495,1.661,8.736,8.736,0,0,0-3.992,4.521A1.21,1.21,0,1,0,5.622,22a6.332,6.332,0,0,1,2.921-3.238,10.438,10.438,0,0,1,4.27-1.294A3.636,3.636,0,0,1,15.436,15.092Z",
    transform: "translate(20272.223 -2174.691)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5890",
    "data-name": "Tracciato 5890",
    d: "M18,14v9.678",
    transform: "translate(20275.313 -2174.902)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5891",
    "data-name": "Tracciato 5891",
    d: "M23.678,18H14",
    transform: "translate(20274.473 -2174.063)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondividi);
export default __webpack_public_path__ + "static/media/condividi.792fc4ba2a86306c213ba8af24289b05.svg";
export { ForwardRef as ReactComponent };